import { render, staticRenderFns } from "./ProductSpecsIndex.vue?vue&type=template&id=2d9b739a&scoped=true"
import script from "./ProductSpecsIndex.vue?vue&type=script&lang=js"
export * from "./ProductSpecsIndex.vue?vue&type=script&lang=js"
import style0 from "./ProductSpecsIndex.vue?vue&type=style&index=0&id=2d9b739a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d9b739a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d9b739a')) {
      api.createRecord('2d9b739a', component.options)
    } else {
      api.reload('2d9b739a', component.options)
    }
    module.hot.accept("./ProductSpecsIndex.vue?vue&type=template&id=2d9b739a&scoped=true", function () {
      api.rerender('2d9b739a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/productSpecs/ProductSpecsIndex.vue"
export default component.exports